import * as types from './actionTypes';

export const showSpinner = payload => ({
    type: types.SHOW_SPINNER,
    payload
});

export const hideSpinner = () => ({
    type: types.HIDE_SPINNER
});